"use client";

import React from "react";
import { Box } from "@mui/material";
import { ColletteCarousel } from "@collette-travel/collette-common-controls";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";
import { Image } from "@/types/dto/common/image";
import ReviewMediaCard from "./review-media-card";

type ReviewCarouselProps = {
  testimonials: {
    testimonialCardId?: string;   
    title?: string;
    starRating?: number;
    copy?: string;
    reviewerNameSocialMediaHandle?: string;
    socialMediaPlatform?: string | null;
    image?: Image;
  }[];
  moduleRankingPosition?: number;
};

const ReviewCarousel = ({ testimonials, moduleRankingPosition }: ReviewCarouselProps) => {
  const isLg = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  return (
    <Box
      className="pattern-bg"
      component="section"
      data-track="visibility"
      data-ranking-position={moduleRankingPosition}
      data-module-name="awards-reviews-carousel"
      data-module-type="carousel"
      data-testid="review-carousel-section"
    >
      <Box
        className="full-width-container"
        sx={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          overflow: "hidden",
          p: { xs: "4rem 2.4rem", sm: "4rem 3.2rem", lg: "6rem 10rem" }
        }}
      >
        <ColletteCarousel
          testId="review-carousel"
          arrowPosition={isLg ? "sides" : "bottom"}
          variant="full-width"
          showDots
        >
          {testimonials.map((testimonial, index) => (
            <Box key={testimonial?.testimonialCardId || index}>
              <ReviewMediaCard testimonial={testimonial} index={index} />
            </Box>
          ))}
        </ColletteCarousel>
      </Box>
    </Box>
  );
};

export default ReviewCarousel;
